import React from "react";
import AdminShell from "@/pages/admin/AdminShell";
import { TasksAI } from "@/pages/constructor/ConstructorDashboard";

export default function TasksPage() {
  return <AdminShell><TasksAI /></AdminShell>;
}
